import React from 'react';
import marketingIcon from '../assets/images/marketing.svg';

export const MarketingIcon = () => {
  return <img src={marketingIcon} style={{ width: '24px', color: 'rgba(0, 0, 0, 0.54)' }} />;
};
